import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { PrimeNG } from 'primeng/config';
import { ThemeService } from './core/services/theme.service';
import { PestanaDelNavegador } from './core/services/pestana-del-navegador';
import { GlobalUpgradeDialogComponent } from './shared/components/global-upgrade-dialog/global-upgrade-dialog.component';
import { SrDocLoadingComponent } from './shared/components/sr-doc-loading/sr-doc-loading.component';
import { SrToastHostComponent } from './shared/components/sr-toast/sr-toast-host.component';

@Component({
  selector: 'app-root',
  standalone: true,
  // #545 · Toasts del DS v16 vía <sr-toast-host> (reemplaza <p-toast> de PrimeNG).
  imports: [CommonModule, RouterOutlet, ConfirmDialogModule, ButtonModule, TooltipModule,
    GlobalUpgradeDialogComponent, SrDocLoadingComponent, SrToastHostComponent],
  template: `
    <router-outlet></router-outlet>
    <app-global-upgrade-dialog></app-global-upgrade-dialog>
    <sr-doc-loading></sr-doc-loading>
    <sr-toast-host></sr-toast-host>
    <p-confirmDialog></p-confirmDialog>
  `,
})
export class AppComponent implements OnInit {
  // PestanaDelNavegador no se usa aquí: basta con instanciarlo para que lleve el título de la pestaña al navegador.
  constructor(private primeng: PrimeNG, private theme: ThemeService, _pestana: PestanaDelNavegador) { }

  ngOnInit() {
    this.primeng.ripple.set(true);
    // Aplicamos la traducción al español
    this.primeng.setTranslation({
      firstDayOfWeek: 1,
      dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
      dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
      dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
      monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
      monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
      today: 'Hoy',
      clear: 'Limpiar',
      dateFormat: 'dd/mm/yy',
      weekHeader: 'Sem',
      // Los rótulos que no se ven (aria-label) también: sin estos, el calendario decía «Choose Date» en inglés.
      chooseDate: 'Elegir fecha',
      chooseMonth: 'Elegir mes',
      chooseYear: 'Elegir año',
      prevMonth: 'Mes anterior',
      nextMonth: 'Mes siguiente',
      prevYear: 'Año anterior',
      nextYear: 'Año siguiente',
      prevDecade: 'Década anterior',
      nextDecade: 'Década siguiente',
    });
  }
}
